import { closeModal } from '../common/modals';
import Cookies from 'js-cookie';

( () => {
    const $cookiesNotice = document.querySelector('.cookies-notice');
    const $acceptAllBtn = document.querySelector('.cookies-notice__accept-all-btn');
    const $cookiesForm = document.querySelector('.cookies-notice__form');

    if ( !$cookiesNotice ) return;
    

    const acceptCookies = (allowNecessaryCookies, allowAnalyticalCookies, allowMarketingCookies) => {
        if ( !allowNecessaryCookies ) {
            Cookies.remove('cookieConsent');
            return;
        }

        Cookies.set('cookieConsent', { 
            necessary: allowNecessaryCookies ? true : false,
            analytical: allowAnalyticalCookies ? true : false,
            marketing: allowMarketingCookies ? true : false
        }, { expires: 7 });

        $cookiesNotice.classList.add('hide');

        setTimeout(() => {
            $cookiesNotice.parentNode.removeChild($cookiesNotice);
        }, 250);
    };

    if ( $acceptAllBtn ) {
        $acceptAllBtn.addEventListener('click', () => {
            acceptCookies(true, true, true);
        });
    }

    if ( $cookiesForm ) {
        $cookiesForm.addEventListener( 'submit', e => {
            e.preventDefault();

            const necessaryCookies = e.target.querySelector('input[name="necessary-cookies"]');
            const analyticalCookies = e.target.querySelector('input[name="analytical-cookies"]');
            const marketingCookies = e.target.querySelector('input[name="marketing-cookies"]');

            acceptCookies(necessaryCookies.checked, analyticalCookies.checked, marketingCookies.checked);

            closeModal(document.querySelector('.cookies-notice__options'));
        } );
    }
} )();
